import React from 'react'

const LeaveRequests = () => {
  return (
    <div>LeaveRequests</div>
  )
}

export default LeaveRequests